<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item
        label="序列号"
        prop="code"
      >
        <a-input
          v-model="form.code"
          placeholder="请输入"
        />
      </a-form-model-item>
      <a-form-model-item
        label="验证码"
        prop="verificationCode"
      >
        <a-input
          v-model="form.verificationCode"
          placeholder="请输入"
        />
      </a-form-model-item>
      <a-form-model-item
        label="设备说明	"
        prop="name"
      >
        <a-input
          v-model="form.name"
          placeholder="请输入"
        />
      </a-form-model-item>
      <a-form-model-item
        label="备注	"
        prop="remark"
      >
        <a-input
          v-model="form.remark"
          placeholder="请输入"
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button
            type="primary"
            :loading="submitLoading"
            @click="submitForm"
          >
            {{ $t('保存') }}
          </a-button>
          <a-button
            type="dashed"
            @click="cancel"
          >
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>

import { addPage } from '@/api/device'
import { unDoIcon } from 'amis-ui'

export default {
  name: 'CreateForm',
  props: ['devId'],
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      showId: '',
      // 表单参数
      form: {
        id: undefined,
        verificationCode: undefined,
        remark: undefined,
        orderNum: 0,
        name: undefined,
        devId: undefined,
        deptId: undefined,
        code: undefined
      },
      open: false,
      typeOptions: [],
      listDate: [],
      depID: '',
      rules: {
        code: [{ required: true, message: '请输入序列号', trigger: 'blur' }],
        verificationCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      }
    }
  },
  filters: {
  },
  created () {
    // listType({ pageSize: 9999, pageNum: 1 }).then(res => {
    //   console.log(res, 'ddd嘟嘟嘟嘟');
    //   this.listDate = res.data
    // })
  },
  computed: {
  },
  watch: {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.form = {
        id: undefined,
        verificationCode: undefined,
        remark: undefined,
        orderNum: 0,
        name: undefined,
        devId: undefined,
        deptId: undefined,
        code: undefined,
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      console.log('row', row)
      this.showId = row
      this.reset()
      // if (row !== undefined) {
      //   this.form.parentId = row.id
      // }
      this.open = true
      this.formTitle = '添加摄像头'
    },
    /** 提交按钮 */
    submitForm: function () {
      let that = this
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          this.form.devId = this.devId
          addPage(this.form).then(response => {
            this.$message.success(
              '新增成功',
              3
            )
            this.open = false
            this.$emit('ok', this.showId)
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
